import React, { createContext, useContext, useState } from 'react';

const HintsContext = createContext();

export const HintsProvider = ({ children }) => {
  const [hintsVisible, setHintsVisible] = useState(() => {
    return localStorage.getItem('zapmanejo_hints') !== 'false';
  });

  const showHints = () => {
    localStorage.setItem('zapmanejo_hints', 'true');
    setHintsVisible(true);
  };

  const hideHints = () => {
    localStorage.setItem('zapmanejo_hints', 'false');
    setHintsVisible(false);
  };

  return (
    <HintsContext.Provider value={{ hintsVisible, showHints, hideHints }}>
      {children}
    </HintsContext.Provider>
  );
};

export const useHints = () => useContext(HintsContext);
